import { FC, useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import {
  ExpandedTable,
  IButton,
  Spinner,
  StoredPagination,
  ITooltip,
} from "../../ui-kit";
import { PlusIco, TrashIco } from "../../assets/customIcons";
import SmsSettingsTemplateForm from "./form/template";
import dictionaryStore from "../../store/dictionary";
import smsSettings from "../../store/smsSettings";
import { useStatusMessage } from "../../hooks/useStatusMessage";

import styles from "./SmsSettings.module.scss";
import Constants from "../../constants/Common";


export type SmsSettingTemplateType = {
  id?: number;
  title: string;
  description: string;
  textDesign: string;
  meta?: any;
  eventSeverityId: number;
  eventSeverityName: string;
};

const INITIAL_TEMPLATE_DATA: SmsSettingTemplateType = {
  id: 0,
  title: "",
  eventSeverityId: null,
  eventSeverityName: null,
  description: "",
  textDesign: "",
};

const SmsSettingsText: FC = observer(() => {
  const {
    titleIcons: { trash },
  } = Constants;
  const {
    templateStatus,
    templatesAreLoading,
    templatesData,
    templatesDataPaginator,
    templatesRowKeys,
  } = smsSettings;

  const [addForm, toggleAddForm] = useState(false);

  useStatusMessage(templateStatus);

  useEffect(() => {
    smsSettings.getSmsIncidentsParams(false);
    dictionaryStore.getDictionaryData("NotificationTemplateItem");
  }, []);

  useEffect(() => {
    smsSettings.getSmsTemplates();
  }, [templatesDataPaginator.page, templatesDataPaginator.perPage]);

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Название шаблона",
      dataIndex: "title",
      key: "title",
      width: "20%",
      className: "align-left",
    },
    {
      title: "Описание шаблона",
      dataIndex: "description",
      key: "description",
      width: "70%",
      className: "align-left",
    },
    {
      title: " ",
      key: "delete",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco onClick={(e) => deleteData(e, record.id)} />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  const deleteData = (e, id) => {
    e.stopPropagation();

    smsSettings.deleteSmsTemplate(id);
  };

  return (
    <div className={styles.SmsSettingsPage}>
      <ExpandedTable
        columns={columns}
        data={templatesData}
        rowKey={(record) => record.id}
        rowKeys={templatesRowKeys.keys}
        setRowKeys={templatesRowKeys.setKeys}
        rowsLength={templatesDataPaginator.perPage}
        loading={templatesAreLoading.value}
      >
        <SmsSettingsTemplateForm />
      </ExpandedTable>
      <StoredPagination {...templatesDataPaginator} />
      <IButton
        size="medium"
        onClick={(e) => toggleAddForm((addForm) => !addForm)}
        className={styles.SmsSettingsAddButton}
      >
        <PlusIco /> Добавить шаблон
      </IButton>
      {addForm && <SmsSettingsTemplateForm record={INITIAL_TEMPLATE_DATA} />}
    </div>
  );
});

export default SmsSettingsText;
